export default "__VITE_ASSET__078a8676__"